<script>
import { formatHashrate, formatDuration } from "@/utils";
import { mapState } from "vuex";

import List from "@/components/List";

export default {
  // Included components
  components: {
    List,
  },

  props: {
    // The alert to describe
    alert: {
      type: Object,
      requred: true,
    },

    // An optional alert event to describe
    event: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState(["workers"]),
  },

  methods: {
    // Helper functions and actions
    formatHashrate,
    formatDuration,
  },
};
</script>

<template>
  <span>
    <span v-if="!event">
      <span v-if="alert.kind == 'HASHRATE_FALLS_BELOW'">
        <b-link :to="`/groups/${alert.group.id}`">
          {{ alert.group.name }}
        </b-link>
        's hashrate falls
        {{ alert.hashrate_threshold == 0 ? "to" : "below" }}
        {{ formatHashrate(alert.hashrate_threshold) }}
        <span v-if="alert.time_threshold > 300">
          for more than {{ formatDuration(alert.time_threshold) }}
        </span>
      </span>
      <span v-else-if="alert.kind == 'WORKER_HASHRATE_FALLS_BELOW'">
        Any worker in
        <b-link :to="`/groups/${alert.group.id}`">
          {{ alert.group.name }}
        </b-link>
        falls
        {{ alert.hashrate_threshold == 0 ? "to" : "below" }}
        {{ formatHashrate(alert.hashrate_threshold) }}
        <span v-if="alert.time_threshold > 300">
          for more than {{ formatDuration(alert.time_threshold) }}
        </span>
      </span>
    </span>
    <span v-else>
      <span v-if="event.alert_kind == 'HASHRATE_FALLS_BELOW'">
        <b-link :to="`/groups/${event.alert_group_id}`">
          {{ event.alert_group_name }}
        </b-link>
        's hashrate fell
        {{ event.trigger_parameters.hashrate_threshold == 0 ? "to" : "below" }}
        {{ formatHashrate(event.trigger_parameters.hashrate_threshold) }}
        <span v-if="event.trigger_parameters.time_threshold > 300">
          for more than
          {{ formatDuration(event.trigger_parameters.time_threshold) }}
        </span>
      </span>
      <span v-else-if="event.alert_kind == 'WORKER_HASHRATE_FALLS_BELOW'">
        {{ event.trigger_parameters.low_workers_count }} worker{{
          event.trigger_parameters.low_workers_count != 1 ? "s" : ""
        }}
        <span
          v-if="
            event.trigger_parameters.low_workers &&
            event.trigger_parameters.low_workers.length > 0
          "
        >
          (
          <List etc :items="event.trigger_parameters.low_workers">
            <template #default="{ item }">
              <b-link :to="`/workers/${item.worker_id}`">
                {{
                  workers[item.worker_id]
                    ? workers[item.worker_id].name
                    : "unknown"
                }}
              </b-link>
            </template>
          </List>
          )
        </span>
        fell
        {{ event.trigger_parameters.hashrate_threshold == 0 ? "to" : "below" }}
        {{ formatHashrate(event.trigger_parameters.hashrate_threshold) }}
        <span v-if="event.trigger_parameters.time_threshold > 300">
          for more than
          {{ formatDuration(event.trigger_parameters.time_threshold) }}
        </span>
      </span>
    </span>
  </span>
</template>
